// A write the page must still get out while it is being unloaded (`pagehide`): the worker that owns
// REST is terminated at that moment (bridge/client.ts), so these go straight from the page with
// `fetch(…, {keepalive: true})` — the browser finishes the request after the page is gone. Same
// headers the worker's NetworkClient sends (session cookie, `X-CSRF-Token` from MMCSRF,
// `X-Requested-With`, `X-Satori-Client`). Best-effort: never awaited, failures ignored (the server
// forgets a viewer after 50 s, a call status after its 10-minute expiry).
import { mediaBase } from './media';

function readCookie(name: string): string | null {
  for (const part of document.cookie.split(';')) {
    const [k, ...v] = part.trim().split('=');
    if (k === name) return decodeURIComponent(v.join('='));
  }
  return null;
}

export function keepaliveRequest(method: 'POST' | 'PUT' | 'DELETE', path: string, body?: unknown): void {
  try {
    const headers: Record<string, string> = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-Satori-Client': `web/${__APP_VERSION__}`,
      Accept: 'application/json',
    };
    const csrf = readCookie('MMCSRF');
    if (csrf) headers['X-CSRF-Token'] = csrf;
    if (body !== undefined) headers['Content-Type'] = 'application/json';
    void fetch(`${mediaBase()}${path}`, {
      method,
      keepalive: true,
      credentials: 'include',
      headers,
      body: body === undefined ? undefined : JSON.stringify(body),
    }).catch(() => undefined);
  } catch {
    /* unloading: nothing to tell anyone */
  }
}
